<app-header></app-header>

<div class="min-h-screen flex items-center short:items-start justify-center px-4 sm:px-6 md:px-8 short:pt-24 short:pb-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employee-login.png)' }">
    <div class="bg-white p-4 sm:p-6 md:p-8 short:py-3 rounded-lg w-full max-w-2xl mt-4 short:mt-0 card-shadow">
        <div class="flex justify-start mb-4 sm:mb-6 short:mb-2 pb-2 short:pb-1 border-b-[1px] ">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14 short:h-10" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ 'EMPLOYEE.PASSWORD.TITLE' | translate }}
        </h2>

        <div>
            <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 short:mb-2 font-light">
                {{ 'EMPLOYEE.PASSWORD.DESCRIPTION' | translate }}
            </p>
            <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="flex justify-center">
                <div class="w-full max-w-md px-2 sm:px-0">
                    <div class="mb-2 short:mb-1">
                        <label class="block text-gray-400 font-light italic text-base sm:text-lg mb-2 sm:mb-4 short:mb-1">{{
                            'EMPLOYEE.PASSWORD.EMAIL_ADDRESS_LABEL' | translate }}</label>
                        <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none" formControlName="email"
                            placeholder="{{ 'EMPLOYEE.PASSWORD.EMAIL_ADDRESS_LABEL' | translate }}" tabindex="1" />
                        <div *ngIf="passwordForm.get('email')?.invalid && (passwordForm.get('email')?.dirty || passwordForm.get('email')?.touched)"
                            class="text-red-500 text-xs sm:text-sm mt-1">
                            <div *ngIf="passwordForm.get('email')?.errors?.['required']">{{ 'EMPLOYEE.PASSWORD.EMAIL_REQUIRED' | translate }}</div>
                            <div *ngIf="passwordForm.get('email')?.errors?.['email']">{{ 'EMPLOYEE.PASSWORD.EMAIL_INVALID' | translate }}</div>
                        </div>
                    </div>

                    <div *ngIf="errorMessage" class="text-red-600 text-xs sm:text-sm text-left mb-4">
                        {{ errorMessage }}
                    </div>

                    <button type="submit" [disabled]="passwordForm.invalid"
                        class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium min-h-[48px]"
                        [ngClass]="{ 'opacity-50 cursor-default': passwordForm.invalid, 'active:bg-red-500 active:text-white': !passwordForm.invalid }">
                        {{ 'EMPLOYEE.PASSWORD.RESET_BUTTON' | translate }}
                    </button>
                </div>
            </form>
        </div>

        <div class="text-center mt-4 sm:mt-6 short:mt-2">
            <a routerLink="/employee/account/login" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">
                {{ 'EMPLOYEE.PASSWORD.BACK_TO_LOGIN' | translate }}
            </a>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>
